// extracted by mini-css-extract-plugin
module.exports = {"md":"SettingsSlot_md_153Jg","ios":"SettingsSlot_ios_2hx_7"};